import { render } from "./AsistenteIAUser.vue?vue&type=template&id=5b81d520"
import script from "./AsistenteIAUser.vue?vue&type=script&lang=js"
export * from "./AsistenteIAUser.vue?vue&type=script&lang=js"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__